import { render, staticRenderFns } from "./ProfEmailSettings.vue?vue&type=template&id=758c9309&"
import script from "./ProfEmailSettings.vue?vue&type=script&lang=js&"
export * from "./ProfEmailSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports